/*
 * Product cards (snippets/product-card.liquid)
 * On one-card-per-product cards, hovering, focusing or tapping a colour swatch
 * shows that colour's images, link and price. Listens on the document so it keeps
 * working when a grid is re-rendered (filtering, sorting, paging).
 */
(() => {
    if (window.productCardSwatchesReady) return;
    window.productCardSwatchesReady = true;

    const setImage = (img, src, srcset) => {
        if (!img) return;
        img.srcset = srcset || '';
        img.src = src;
    };

    const selectSwatch = (swatch) => {
        if (swatch.getAttribute('aria-pressed') === 'true') return;

        const card = swatch.closest('[data-product-item]');
        if (!card) return;
        const { url, image, imageSrcset, secondImage, secondImageSrcset, price } = swatch.dataset;

        card.querySelectorAll('[data-card-swatch]').forEach((other) => {
            other.setAttribute('aria-pressed', other === swatch ? 'true' : 'false');
        });

        setImage(card.querySelector('[data-product-image-default] img'), image, imageSrcset);

        // The hover image only shows when this colour has one
        const under = card.querySelector('.product-item__bg__under');
        card.querySelector('[data-product-image]')?.classList.toggle('double__image', Boolean(secondImage));
        if (under) {
            under.hidden = !secondImage;
            if (secondImage) setImage(under.querySelector('img'), secondImage, secondImageSrcset);
        }

        card.querySelectorAll('.product-link').forEach((link) => {
            link.href = url;
            link.dataset.productLink = url;
        });

        const priceHolder = card.querySelector('.product-item__price');
        if (priceHolder && price) priceHolder.innerHTML = price;
    };

    const onSwatch = (event) => {
        const swatch = event.target.closest?.('[data-card-swatch]');
        if (swatch) selectSwatch(swatch);
    };

    document.addEventListener('pointerover', onSwatch);
    document.addEventListener('focusin', onSwatch);
    document.addEventListener('click', onSwatch);
})();
